import React, { useEffect, useState } from 'react';
import { FaExclamationCircle, FaCheck, FaTimesCircle, FaCheckCircle, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Row, Col } from 'react-bootstrap';
import './HealthInsights.css';
import DynamicGrid from './DynamicGrid';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGeneInfo, fetchHealthInfo, fetchBlastOffReferenceResult } from '../actions';
import Loading from './loading';
import { colorExplanation } from '../jsonObject/colorExplanation';
//build changes
const HealthInsights = ({ kitData, petName }) => {
    const dispatch = useDispatch();
    const [ruleResult, setRuleResult] = useState([]);
    const [geneResult, setGeneResult] = useState([]);
    const [referenceResult, setReferenceResult] = useState([]);
    const [trueCount, setTrueCount] = useState(0);
    const [trueCountCarrier, setTrueCountCarrier] = useState(0);
    const [falseCount, setFalseCount] = useState(0);
    const [showAll, setShowAll] = useState(false);
    const [expandedPanel, setExpandedPanel] = useState(null);
    const [isFetchingData, setIsFetchingData] = useState(false);
    const healthInfo = useSelector(state => state.health.healthInfo);
    const loading = useSelector(state => state.health.loading);
    const geneInfo = useSelector(state => state.gene.geneInfo);
    const referenceInfo = useSelector(state => state.reference.referenceInfo);
    const [filteredResults, setFilteredResults] = useState([]);
    const [selectedSubHealth, setSelectedSubHealth] = useState('All');
    const [subHealthSection, setSubHealthSection] = useState([]);
    const [selectedRiskType, setSelectedRiskType] = useState();
    const noData = "No data available";

    useEffect(() => {
        dispatch(fetchHealthInfo(kitData.Kit_id));
    }, [dispatch, kitData.Kit_id]);

    useEffect(() => {
        if (healthInfo?.ItemInfo) {
            const filteredResult = prioritizeHealthTraits(healthInfo.ItemInfo);
            let affectedCount = 0;
            let carrierCount = 0;

            filteredResult.forEach(item => {
                if (item?.status === "affected") {
                    affectedCount++;
                }
                if (item?.status === "Carrier") {
                    carrierCount++;
                }
            });
            setTrueCount(affectedCount);
            setTrueCountCarrier(carrierCount);
            console.log("affectedCount", affectedCount, "carrierCount", carrierCount);
            const subHealthSectionArr = Array.from(new Set(healthInfo.ItemInfo.map(item => item.sub_health_category)))
                .map(category => ({
                    name: category,
                    icon: null
                }));
            const seen = new Set();
            const uniqueBodyParts = [];

            subHealthSectionArr.forEach(item => {
                if (!item.name) return;

                const parts = item.name.split(',').map(part => part.trim());

                for (const part of parts) {
                    const lowerPart = part.toLowerCase();
                    if (!seen.has(lowerPart)) {
                        seen.add(lowerPart);
                        uniqueBodyParts.push({ name: part });
                        break; // Only take the first unseen part
                    }
                }
            });
            setSubHealthSection(uniqueBodyParts);
            setRuleResult(filteredResult);
            filterData(filteredResult);
        }
    }, [healthInfo, selectedSubHealth, selectedRiskType]);

    useEffect(() => {
        if (referenceInfo?.ItemInfo) {
            const filteredReferenceInfo = referenceInfo?.ItemInfo.filter((item, index, self) => self.indexOf(item) === index);
            setReferenceResult(filteredReferenceInfo);
        }
        else {
            setReferenceResult([]);
        }
        if (geneInfo?.ItemInfo) {
            const statusPriority = {
                "affected": 0,
                "carrier": 1,
                "normal": 2
            };
            const geneData = geneInfo.ItemInfo
                .filter(condition => {
                    const chromosome = condition.chromosome;
                    const position = condition.position;
                    const statusExclusion = condition.status !== 'missing_genotype';
                    return chromosome && position && statusExclusion;
                })
                .sort((a, b) => {
                    const statusA = statusPriority[a.status] ?? 3;
                    const statusB = statusPriority[b.status] ?? 3;

                    if (statusA !== statusB) return statusA - statusB;

                    const chromA = parseInt(a.chromosome.replace('chr', '')) || 100;
                    const chromB = parseInt(b.chromosome.replace('chr', '')) || 100;

                    if (chromA !== chromB) return chromA - chromB;
                    return a.position - b.position;
                });
            setGeneResult(geneData);
        }
        setIsFetchingData(false);

    }, [geneInfo, referenceInfo]);

    const filterData = (data) => {
        const filteredData = data.filter(condition => {
            const subHealthMatch = selectedSubHealth === "All" || (condition.sub_health_category && condition.sub_health_category.toLowerCase().includes(selectedSubHealth.toLowerCase()));
            const riskTypeMatch = selectedRiskType === "All" || condition.status === selectedRiskType;
            const statusExclusion = condition.status !== 'missing_genotype';
            return subHealthMatch && riskTypeMatch && statusExclusion;
        });

        filteredData.sort((a, b) => {
            if (a.status === 'affected' && b.status !== 'affected') return -1;
            if (a.status !== 'affected' && b.status === 'affected') return 1;
            return 0;
        });

        setFilteredResults(filteredData);
        let trueCount1 = 0;
        let trueCountCarrier1 = 0
        let falseCount1 = 0;
        filteredData.forEach(condition => {
            if (condition.status === 'affected') {
                trueCount1++;
            } else if (condition.status === 'Carrier') {
                trueCountCarrier1++;
            } else {
                falseCount1++;
            }
        });
        // setTrueCountCarrier(trueCountCarrier1);
        // setTrueCount(trueCount1);

    };

    const togglePanel = async (condition, panelIndex) => {
        const healthTraitId = condition?.health_trait_id;
        setIsFetchingData(true);
        await dispatch(fetchBlastOffReferenceResult(healthTraitId));
        await dispatch(fetchGeneInfo(healthTraitId, kitData.Kit_id));
        if (panelIndex === expandedPanel) {
            setExpandedPanel(null);
        } else {
            setExpandedPanel(panelIndex);
        }
    };

    const handleSubHealthSelect = (subHealth) => {
        setExpandedPanel(null)
        setSelectedSubHealth(subHealth);
    };


    const handleRiskTypeSelect = (riskType) => {
        const clickedType = riskType?.riskType;
        setSelectedRiskType((prev) => (prev === clickedType ? null : clickedType));
    };


    const capitalizeFirstLetter = (string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    const scrollLeft = () => {
        const container = document.getElementById('iconScrollContainer');
        container.scrollBy({ left: -200, behavior: 'smooth' });
    };

    const scrollRight = () => {
        const container = document.getElementById('iconScrollContainer');
        container.scrollBy({ left: 200, behavior: 'smooth' });
    };

    const prioritizeHealthTraits = (data) => {
        const statusPriority = {
            affected: 1,
            Carrier: 2,
            normal: 3,
        };
        const traitMap = {};
        data.forEach(item => {
            const { health_trait_name, status } = item;
            if (!traitMap[health_trait_name]) {
                traitMap[health_trait_name] = item;
            } else {
                if (statusPriority[status] < statusPriority[traitMap[health_trait_name].status]) {
                    traitMap[health_trait_name] = item;
                }
            }
        });
        return Object.values(traitMap);
    };

const replacePlaceholders = (text, petName, gender) => {
    const pronoun = gender === 'female' ? 'she' : 'he';
    const possessivePronoun = gender === 'female' ? 'her' : 'his';
    
    return text
        .replace(/{petName}/g, petName)
        .replace(/{pronoun}/g, pronoun)
        .replace(/{possessivePronoun}/g, possessivePronoun);
};

    return (
        <>
            {loading && <Loading />}
            {/* {isFetchingData && <Loading />} */}
            <div className="healthInsightd">
                <Row className="health-main">
                    <div className="heading">Health Insights</div>
                    <div className="colorExplainContainer">
                        <span>
                            <p className="colorExplainTitleMain">
                               As a devoted pet parent, understanding your dog's genetics can greatly enhance their health and well-being.
                               By analyzing their DNA, we can identify important genetic markers that help predict potential health risks. 
                               This valuable information allows veterinarians to provide personalized care and empowers you to make informed decisions for {petName}.
                            </p>
                        </span>

                        <div className="NameOnT">
                            <p>
                                {petName} has inherited <span className="xcolor">{trueCountCarrier}</span> health insights with One copy
                            </p>
                            <p>
                                {petName} has inherited <span className="xcolor">{trueCount}</span> health insights with Two copies
                            </p>
                        </div>

                        <div className={"colorIconParent"}>
                            <br />
                            {colorExplanation?.map((item, index) => (
                                <div key={index} className="tooltip-wrapper">
                                    <div
                                        onClick={() => {
                                            handleRiskTypeSelect(item);
                                        }}
                                        className={`icon-parent ${selectedRiskType && selectedRiskType !== item?.riskType
                                            ? "move-left"
                                            : ""
                                            }`}
                                    >
                                        {/* <span
                      className="colorIconContainer"
                      style={{
                        backgroundColor:
                          item?.riskType === "affected"
                            ? "#cb0b0b"
                            : item?.riskType === "Carrier"
                            ? "#ffcc00"
                            : "#0c8023",
                      }}
                    >
                      {item?.riskType === "affected" ? (
                        <FaTimesCircleCircle size={40} />
                      ) : item?.riskType === "Carrier" ? (
                        <FaExclamationCircle size={40} />
                      ) : (
                        <FaCheckCircle size={40} />
                      )}
                    </span>
                    */}
                                        <div className="blueCont-wrapper">
                                            <div >
                                                {selectedRiskType === item?.riskType ? (
                                                    <p className="colorExplainTitle">
                                                        <span className="itemsubt">
                                                            <strong>{item?.sub_title}</strong>
                                                        </span>


                - {replacePlaceholders(item?.riskDescription, petName, kitData?.Gender)}
                                                    </p>
                                                ) : (
                                                    <h1 className="color-icon-title">
                                                        {item?.sub_title}
                                                    </h1>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <span className="tooltip-text">
                                        Click to view Health Results
                                    </span>
                                    {/* changes done here for rsik.description*/}
                                </div>
                            ))}
                            {/* <span className='colorIconContainer' onClick={() => handleRiskTypeSelect('All')} style={{ backgroundColor: 'rgb(13 121 120)', }}
                        >
                            <div>All</div>
                        </span> */}
                        </div>
                    </div>
                </Row>

                {/* <Row className="justify-content-center">
                    <div className="heading">Health Results</div>
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "24px",
                            color: "#636467",
                        }}
                    >
                        {petName} only has{" "}
                        <span style={{ color: "red", fontWeight: "bold" }}>
                            {trueCount}
                        </span>{" "}
                        genetic health risk.
                    </div>
                </Row> */}
                <Row className="justify-content-center">
                    <div className="icon-container">
                        <div className="arrow-button" onClick={scrollLeft}>
                            <FaChevronLeft />
                        </div>
                        <div className="icon-scroll-container" id="iconScrollContainer">
                            <div
                                className={`icon-holder ${selectedSubHealth === "ALL" ? "active" : ""
                                    }`}
                                onClick={() => handleSubHealthSelect("All")}
                            >
                                <div className="subHeadButtonTest">
                                    <p className="subHealthTitle">All</p>
                                </div>
                            </div>
                            {subHealthSection.map((subHealth, index) => (
                                <div
                                    className={`icon-holder ${selectedSubHealth === subHealth.name ? "active" : ""
                                        }`}
                                    key={index}
                                    onClick={() =>
                                        handleSubHealthSelect(subHealth?.name, index)
                                    }
                                >
                                    <div className="subHeadButtonTest">
                                        <p className="subHealthTitle">
                                            {subHealth?.name
                                                ? capitalizeFirstLetter(subHealth?.name)
                                                : noData}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="arrow-button" onClick={scrollRight}>
                            <FaChevronRight />
                        </div>
                    </div>
                </Row>
                <Row style={{ marginTop: "0" }}>
                    <div style={{ maxWidth: "100vw", margin: "auto" }}>
                        {filteredResults?.map((condition, index) => (
                            <div key={index}>
                                <Row
                                    style={{
                                        margin: "5px 10px",
                                        padding: "0",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => togglePanel(condition, index)}
                                >
                                    <Col xs={3}></Col>
                                    <Col xs={7} className="row trait-col">
                                        <div style={{ alignItems: "center" }}>
                                            <span style={{ fontSize: 22, fontWeight: "bold", width: '90%' }}>
                                                {condition?.health_trait_name}
                                            </span>
                                            <span
                                                className="variant-parent"
                                                style={{
                                                    background:
                                                        condition?.status === "affected"
                                                            ? "#cc00009e"
                                                            : condition?.status === "Carrier"
                                                                ? "#ffcc00"
                                                                : "#01ad4e",
                                                }}
                                            >
                                                {condition?.status === "affected" ? (
                                                    <span className="xiconColor">
                                                        <FaTimesCircle size={30} />
                                                    </span>
                                                ) : condition?.status === "Carrier" ? (
                                                    <FaExclamationCircle size={30} />
                                                ) : (
                                                    <span className="checkiconColor">
                                                        <FaCheckCircle size={30} />
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>

                                {expandedPanel === index && (
                                    <div>
                                        <div>
                                            <div className="condition-container">
                                                <p className="traitCard1" style={{ padding: "10px" }}>
                                                    <h3
                                                        style={{
                                                            fontSize: 24,
                                                            textAlign: "left",
                                                            marginVertical: "4vw",
                                                        }}
                                                    >
                                                        {"About"}
                                                    </h3>
                                                    {condition?.condition_details}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="condition-container">
                                            <DynamicGrid items={condition} />
                                        </div>

                                        <div className="condition-container">
                                            <h3
                                                className="diseaseHeader"
                                                style={{
                                                    fontSize: 42,
                                                    textAlign: "center",
                                                    margin: "2vw",
                                                }}
                                            >
                                                {"Scientific Details"}
                                            </h3>
                                            {geneResult === undefined ? null : (
                                                <Row className="scientific-container">
                                                    <Col className="scientific-col" xs={4}>
                                                        <Row>
                                                            <span className="scientific-title">
                                                                {"Chromosome"}
                                                            </span>
                                                        </Row>
                                                        {geneResult?.map((scientificDetail, index) => (
                                                            <Row key={scientificDetail?.chromosome}>
                                                                <span className="scientific-detail">
                                                                    {scientificDetail?.chromosome}
                                                                </span>
                                                            </Row>
                                                        ))}
                                                    </Col>
                                                    <Col className="scientific-col" xs={4}>
                                                        <Row>
                                                            <span className="scientific-title">
                                                                {"Position"}
                                                            </span>
                                                        </Row>
                                                        {geneResult?.map((scientificDetail, index) => (
                                                            <Row key={scientificDetail?.position}>
                                                                <span className="scientific-detail">
                                                                    {scientificDetail?.position}
                                                                </span>
                                                            </Row>
                                                        ))}
                                                    </Col>
                                                    <Col
                                                        className="scientific-col"
                                                        style={{ borderRight: 0 }}
                                                        xs={4}
                                                    >
                                                        <Row>
                                                            <span className="scientific-title">
                                                                {"Status"}
                                                            </span>
                                                        </Row>
                                                        {geneResult?.map((scientificDetail, index) => (
                                                            <Row key={scientificDetail?.status}>
                                                                <span className="scientific-detail">
                                                                    {capitalizeFirstLetter(
                                                                        scientificDetail?.status
                                                                    )}
                                                                </span>
                                                            </Row>
                                                        ))}
                                                    </Col>
                                                </Row>
                                            )}
                                        </div>
                                        <div className='condition-container'>
                                            <h3 className="reference-header">{"References"}</h3>
                                            {referenceResult !== undefined ? (
                                                <div>
                                                    <ul>
                                                        {referenceResult
                                                            ?.slice(0, showAll ? referenceResult.length : 2)
                                                            .map((reference, index) => (
                                                                <li key={index} className="reference-item">
                                                                    {reference?.reference}
                                                                </li>
                                                            ))}
                                                    </ul>
                                                    <button
                                                        onClick={toggleShowAll}
                                                        className="show-more-button"
                                                    >
                                                        {showAll ? "Show Less" : "Show More..."}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="reference-item">{noData}</div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </Row>
            </div>
        </>
    );
};
export default HealthInsights;